import { FormModal } from "../../../lib/ui/controls/FormModal";
import { MethodPackManager } from "../../MethodPackManager";
import { BigNisButton } from "../widgets/BigNisButton";
import { NewMethodPackModal } from "./MethodPackModal";
import TextField from "../../../lib/ui/controls/TextField";
import TextArea from "../../../lib/ui/controls/TextArea";
import Properties from "../widgets/Properties";
import { AssumptionProperty } from "./AssumptionProperty";
import { SolvingMethods } from "../../model/SolvingMethods";
import { DropdownSelection } from "../widgets/DropdownSelection";
import AbstractEditWidget from "../widgets/AbstractEditWidget";
import { util } from "../../../lib/util/util";
var Method = SolvingMethods.Method;
var ClueAssumptions = SolvingMethods.ClueAssumptions;
var copyUpdate = util.copyUpdate;
import { AugmentedMethod, MethodPack } from "../../model/MethodPack";
import { FakeLodash } from "../../../lib/coreutil/FakeLodash";
export class MethodMetaEdit extends AbstractEditWidget {
    constructor(spot, value, include_assumptions = true) {
        super();
        this.spot = spot;
        this.include_assumptions = include_assumptions;
        value.assumptions = ClueAssumptions.filterWithRelevance(value.assumptions, ClueAssumptions.Relevance.forSpot(this.spot));
        this.setValue(value);
    }
    render() {
        this.empty();
        const props = new Properties().appendTo(this);
        const value = this.get();
        props.named("Name", this.name = new TextField()
            .onCommit(v => {
            this.commit(copyUpdate(this.get(), meta => meta.name = v));
        })
            .setPlaceholder("Enter a method name...").setValue(value.name));
        props.header("Description");
        props.row(this.description = new TextArea()
            .setPlaceholder("Optionally enter a description.")
            .onCommit(v => {
            this.commit(copyUpdate(this.get(), meta => meta.description = v));
        })
            .css("height", "80px").setValue(value.description));
        if (this.include_assumptions) {
            props.header("Clue Assumptions");
            props.row(new AssumptionProperty()
                .setValue(value.assumptions)
                .setRelevantAssumptions(ClueAssumptions.Relevance.forSpot(this.spot))
                .onCommit(a => {
                this.commit(copyUpdate(this.get(), meta => meta.assumptions = a));
            }));
        }
    }
}
class MethodPackSelector extends AbstractEditWidget {
    constructor() {
        super();
    }
    async render() {
        this.empty();
        const val = this.get();
        this.selector = new DropdownSelection({
            type_class: {
                toHTML: (pack) => {
                    if (!pack)
                        return c().text("None");
                    if (pack.create_new) {
                        return c().text("Create New");
                    }
                    else {
                        return c().text(pack.pack.name);
                    }
                }
            }
        }, [])
            .setItems(async () => {
            return [
                ...(await MethodPackManager.instance().all()).filter(p => MethodPack.isEditable(p)).map(p => ({ pack: p })),
                { pack: null, create_new: true },
                null
            ];
        })
            .setValue(val ? { pack: val } : null)
            .onSelection(async (s) => {
            if (s?.create_new) {
                this.selector.setValue(null);
                const new_pack = await new NewMethodPackModal().do();
                if (new_pack?.created) {
                    this.commit(new_pack.created);
                }
            }
            else {
                this.commit(s?.pack);
            }
        })
            .appendTo(this);
    }
}
export class NewMethodModal extends FormModal {
    constructor(spot, clone_from = null) {
        super({ size: "small" });
        this.spot = spot;
        this.clone_from = clone_from;
    }
    render() {
        super.render();
        new Properties().appendTo(this.body)
            .named("Pack", this.pack_selector = new MethodPackSelector()
            .setValue(this.clone_from && MethodPack.isEditable(this.clone_from.pack) ? this.clone_from.pack : null)
            .onCommit(p => {
            if (p) {
                const meta = FakeLodash.cloneDeep(this.edit.get());
                meta.assumptions = ClueAssumptions.filterWithRelevance(p.default_assumptions, ClueAssumptions.Relevance.forSpot(this.spot));
                if (!meta.name && p.default_method_name) {
                    meta.name = p.default_method_name;
                }
                this.edit.setValue(meta);
            }
        }));
        if (this.clone_from) {
            this.title.set("Clone Method");
            this.edit = new MethodMetaEdit(this.spot, copyUpdate(Method.meta(this.clone_from.method), cp => {
                cp.name += " (Clone)";
            })).appendTo(this.body);
        }
        else {
            this.title.set("Create New Method");
            this.edit = new MethodMetaEdit(this.spot, { name: "", description: "", assumptions: {} }).appendTo(this.body);
        }
    }
    getButtons() {
        return [
            new BigNisButton("Cancel", "cancel")
                .onClick(() => this.confirm(this.getValueForCancel())),
            new BigNisButton("Create", "confirm")
                .onClick(async () => {
                const base = this.clone_from
                    ? SolvingMethods.clone(this.clone_from.method)
                    : SolvingMethods.init(this.spot);
                Method.setMeta(base, this.edit.get());
                base.assumptions = ClueAssumptions.filterWithRelevance(base.assumptions, ClueAssumptions.Relevance.forSpot(this.spot));
                this.confirm({
                    created: AugmentedMethod.create(base, this.pack_selector.get())
                });
            }),
        ];
    }
    getValueForCancel() {
        return { created: null };
    }
}
export class EditMethodMetaModal extends FormModal {
    constructor(spot, start_value, include_assumptions = true) {
        super({ size: "small" });
        this.spot = spot;
        this.start_value = start_value;
        this.include_assumptions = include_assumptions;
    }
    render() {
        super.render();
        this.title.set("Edit Method Metainformation");
        this.edit = new MethodMetaEdit(this.spot, this.start_value, this.include_assumptions).appendTo(this.body);
    }
    getButtons() {
        return [
            new BigNisButton("Cancel", "cancel")
                .onClick(() => this.confirm(this.getValueForCancel())),
            new BigNisButton("Save", "confirm")
                .onClick(async () => {
                this.confirm({ result: this.edit.get() });
            }),
        ];
    }
    getValueForCancel() {
        return { result: null };
    }
}
